import { VStack, Spinner, Box } from "native-base";
import { useEffect, useState } from "react";
import AccordionDetail from "../../../../components/accordion";
import CustomModal from "../../../../components/modal";
import { getPolicyDocumentsAPI } from "../../../../api/apis/quicklinks";
import { Toaster } from "../../../../components/toaster";
import { COLORS } from "../../../../utils/colors";
import config from "../../../../utils/config";

const PoliciesDocuments = () => {
  const toaster = Toaster();
  const [isOpen, setIsOpen] = useState(false);
  const [openIndex, setOpenIndex] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [policyDoc, setPolicyDoc] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getPolicyDocs();
  }, []);

  const getPolicyDocs = async () => {
    setIsLoading(true);
    let res = await getPolicyDocumentsAPI();
    if (res.error) {
      toaster(res.message, "error", "error");
      return;
    } else {
      let data = [];
      res &&
        res.data.data.data.map((item) => {
          data.push({
            id: item._id,
            title: item?.document_name,
            doc_name: item?.file_name,
            path: config.bucketPath + item?.file_name,
          });
        });
      setPolicyDoc(data);
    }
    setIsLoading(false); // Stop loading
  };

  return (
    <>
      {isLoading ? (
        <Box mt={10} flex={1} alignItems="center" justifyContent="center">
          <Spinner color={COLORS.THEME_COLOR} size="lg" />
        </Box>
      ) : (
        <VStack space={6}>
          {policyDoc.map((item, ind) => {
            return (
              <div key={ind}>
                <AccordionDetail
                  index={ind}
                  isOpen={isOpen && ind === openIndex}
                  setIsOpen={setIsOpen}
                  openIndex={openIndex}
                  setOpenIndex={setOpenIndex}
                  title={item.title}
                  content={item.doc_name}
                  type="policy"
                  path={item.path}
                />
              </div>
            );
          })}
        </VStack>
      )}
    </>
  );
};

export default PoliciesDocuments;
